import React from 'react'

import Roster from './Roster'

class RosterContainer extends React.Component {

  render() {
    let players = this.props.players.sort( (a,b) => new Date(a.joinedAt) - new Date(b.joinedAt) )
    players = players.map( p => {
      p.thumb = p.alive ? '😀' : '💀'
      return p
    })
    return <Roster players={players} />
  }

}

export default RosterContainer



// WEBPACK FOOTER //
// ./src/views/game/components/RosterContainer.jsx